// Rechazos del correo del paso 01 en algo que el vendedor pueda hacer frente al cliente.
// Los códigos del OTP se leen igual que en el teléfono: se reusan sus mensajes.
import { ApiError } from '@/api/errors';
import { sendOtpMessage, verifyOtpMessage } from './otpMessages';

const EMAIL_LOCKED = 'El correo de esta venta ya quedó registrado. Recarga la pantalla.';

/** Al enviar el código o al aceptar términos, el correo resultó ser de otro cliente: se corrige y se pide otro código. */
export const EMAIL_ALREADY_EXISTS_MESSAGE =
    'Este correo ya está registrado con otro cliente. Captura otro correo.';

const SEND_MESSAGE_BY_CODE: Record<string, string> = {
    EMAIL_LOCKED,
    VALIDATION_ERROR: 'Revisa el correo: no tiene un formato válido.',
};

/** «Continuar» rebotó porque el silo no ve el correo verificado. */
export const EMAIL_NOT_VERIFIED_MESSAGE = 'Falta verificar el correo del cliente.';

/** Mensaje cuando falla el ENVÍO del código al correo. */
export function sendEmailOtpMessage(error: unknown): string {
    if (error instanceof ApiError && Object.hasOwn(SEND_MESSAGE_BY_CODE, error.code)) {
        return SEND_MESSAGE_BY_CODE[error.code];
    }
    return sendOtpMessage(error);
}

/** Vencido, usado o sin intentos: «Cambiar correo» sirve también tras recargar, cuando «Reenviar» queda apagado. */
const ASK_NEW_CODE = 'Toca «Cambiar correo» y vuelve a enviar el código.';

const VERIFY_MESSAGE_BY_CODE: Record<string, string> = {
    EMAIL_LOCKED,
    OTP_EXPIRED: `El código venció. ${ASK_NEW_CODE}`,
    OTP_ALREADY_USED: `Ese código ya se usó. ${ASK_NEW_CODE}`,
    OTP_MAX_TRIES: `Se agotaron los intentos con ese código. ${ASK_NEW_CODE}`,
};

/** ¿El silo rechazó el correo porque ya pertenece a otro cliente? */
export function isEmailAlreadyExists(error: unknown): boolean {
    return error instanceof ApiError && error.code === 'EMAIL_ALREADY_EXISTS';
}

/** Mensaje cuando falla la VERIFICACIÓN del código del correo. */
export function verifyEmailOtpMessage(error: unknown): string {
    if (error instanceof ApiError && Object.hasOwn(VERIFY_MESSAGE_BY_CODE, error.code)) {
        return VERIFY_MESSAGE_BY_CODE[error.code];
    }
    return verifyOtpMessage(error);
}
